import {
  AfterViewInit,
  Component, ElementRef,
  EventEmitter, forwardRef,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import {FaqCategory} from '../../../model/FaqCategory';
import {Label} from '../../../model/Label';
import TomSelect from 'tom-select';

type RecursivePartial<T> = {
  [P in keyof T]?: T[P] extends (infer U)[] ? RecursivePartial<U>[] : T[P] extends object | undefined ? RecursivePartial<T[P]> : T[P];
};
import {Product} from "../../../model/product";
import {FaqCategoryService} from "../../../services/faq-category.service";
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from "@angular/forms";


@Component({
    selector: 'app-select2-badges',
    templateUrl: './select2-badges.component.html',
    styleUrls: ['./select2-badges.component.css'],
    imports: [
    FormsModule
],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => Select2BadgesComponent)
        }]
})
export class Select2BadgesComponent implements AfterViewInit, ControlValueAccessor {
  model: any;
  data: RecursivePartial<{ id: string, text: string, additional: FaqCategory | Label }>[];
  categories: FaqCategory[];

  onChange = (value: any[]) => {
  };

  @ViewChild('element') element: ElementRef;

  @Input()
  placeholder: string;

  @Input()
  multiple = true;

  @Input()
  set objects(val: FaqCategory[] | Label[] | Product[] | string[]) {
    this.data = this.dataFromObjects(val);
  }

  @Input()
  set selected(val: FaqCategory[] | Label[] | Product[]) {
    // @ts-ignore
    if(val) {
      this.model = val.map((v: any) => '' + v.id);
    }
  }

  @Output()
  selectedChange = new EventEmitter<RecursivePartial<FaqCategory>[] | RecursivePartial<Label>[] | RecursivePartial<Product>[]>();

  constructor(private catService: FaqCategoryService) {
  }

  dataFromObjects(categories: FaqCategory[] | Label[] | Product[] | string[]): RecursivePartial<{
    id: string,
    text: string,
    additional: FaqCategory | Label
  }>[] {
    // @ts-ignore
    return categories.map((l: FaqCategory | Label | Product | string) => {
      let cat: FaqCategory | Label;
      if (typeof l === "string") {
        cat = this.catService.getFromString(l.toLowerCase());
      } else {
        cat = Product.isProduct(l) ? this.catService.getFromProduct(l) : l;
      }
      return cat !== undefined ? {
        id: '' + cat.id,
        text: cat.name,
        additional: cat
      } : null;
    }).filter(s => s != null);
  }

  ngAfterViewInit(): void {
    // tslint:disable-next-line:no-unused-expression
    new TomSelect(this.element.nativeElement, {
      valueField: 'id',
      searchField: ['text'],
      options: this.data,
      items: this.model,
      hidePlaceholder: true,
      closeAfterSelect: !this.multiple,
      plugins: ['remove_button'],
      onItemAdd(): void {
        this.setTextboxValue('');
        if (this.multiple) {
          this.refreshOptions();
        } else {
          this.blur();
        }
      },
      onChange: (value: string[] | string) => {
        const obj = this.data.filter(p => {
          if(typeof value === "string") {
            return value === p.id
          } else {
            return value.indexOf(p.id) !== -1;
          }
        }).map(p => {
          return p.additional;
        });
        this.selectedChange.emit(obj);
        if (obj.length > 0) {
          this.onChange(obj);
        } else {
          this.onChange(undefined);
        }
      },
      render: {
        option: (data: any, escape: any) => {
          return `
          <div class="option">
            <span class="badge" style="background-color: ${data.additional.backcolor}; color: ${data.additional.textcolor};">${escape(data.text)}</span>
          </div>
          `;
        },
        item: (data: any, escape: any) => {
          return `
          <div class="item badge" style="white-space:wrap; background-color: ${data.additional.backcolor}; color: ${data.additional.textcolor};">
            ${escape(data.text)}
          </div>
          `;
        }
      }
    });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(obj: any): void {
    // obj == slug
    if (obj !== undefined && typeof obj === 'string' && obj !== '') {
      this.selected = [this.catService.getFromString(obj.toLowerCase())];
    } else if (obj !== null) {
      this.selected = obj;
    }
  }

}
